/**************************************************
 * Nombre:       Tarjeta_Sectores_Vista_Dia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import {Add, Remove, ZoomInMapOutlined} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useEffect, useState} from "react";
import Tarjeta_Mesa_Vista_Diaria from "./Tarjeta_Mesa_Vista_Diaria";


const Tarjeta_Sectores_Vista_Dia = ({item, mesas, reservas, click}) => {
    const [open, setOpen] = useState(false);
    const [mesasSector, setMesasSector] = useState([]);



    useEffect(() => {

        if (item && item.nombre){
            let arr = mesas.filter(mesa => mesa.sector === item.nombre);
            setMesasSector(arr);
        }

    },[item])
    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                onClick={() => setOpen(!open)}
                container size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      justifyContent: 'space-between',
                      backgroundColor: theme.palette.primary.main,
                      alignItems: 'center',
                      p: 1,
                      borderRadius: 1,
                      cursor: 'pointer',
                  }}>


                <Typography sx={{color: '#fff', mt: -1, fontWeight: 600}}>
                    <ZoomInMapOutlined sx={{fill: '#fff', pr: 1, mt: 0.7, mb: -0.7}}/>
                    {item.nombre.toUpperCase()}
                </Typography>

                <IconButton onClick={() => setOpen(!open)}>
                    {open ?
                        <Remove sx={{fill: '#fff'}}/>
                        :
                        <Add sx={{fill: '#fff'}}/>
                    }

                </IconButton>

            </Grid>

            <Collapse in={open} timeout="auto" unmountOnExit sx={{width: '100%'}}>


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={3}
                    sx={{mt: 3}}
                >

                    {mesasSector.map((mesa, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Mesa_Vista_Diaria item={mesa} reservas={reservas} click={click}/>
                        </Grid>
                    ))}

                </Grid>

            </Collapse>

        </Grid>
    )

}
export default Tarjeta_Sectores_Vista_Dia